import React from 'react'
import Header from '../../components/Header/Header'
import Footer from '../../components/Footer/Footer'
const investors = () => {
    return (
        <div>
            <Header />
            <section className="banner">
                <div className="banner-blk">

                    <div className="container">
                        <div className="row align-items-center">

                            <div className="col-md-6">
                                <div className="content-blk">

                                    <div className="hero-eyebrow">
                                        <span claclassNamess="hero-dot"></span>
                                        <span className="overline">Series A · Series A · DGA, Inc. / FutureSoulmates™ · 2026</span>
                                    </div>
                                    <h1 className="disp-xl">
                                        The operating system for human
                                        <em className="coral">compatibility.</em>
                                    </h1>
                                    <p className="body-lg">
                                        FutureSoulmates is raising Series A to become the compatibility intelligence layer that every dating and fertility platform plugs into. $150B+ TAM. Product built. Patent filed. API-first B2B SaaS economics.
                                    </p>
                                    <div className="hero-btns">
                                        <button className="btn btn-coral">Request Investor Deck  <span className="arr">→</span></button>
                                        <button className="btn btn-outline">Schedule Call</button>
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-6">
                                <div class="hero-img-stack">
                                    <img alt="" src="/images/investors-banner.jpg" />

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section >

            <div className="sec sec-white">
                <div className="raise-box">
                    <div
                        className="raise-n"
                        style={{ fontSize: "64px" }}
                    >
                        Series A
                    </div>

                    <div
                        className="raise-l"
                        style={{ marginBottom: "12px" }}
                    >
                        Series A · FutureSoulmates™ / DGA, Inc. · New York · 2026
                    </div>

                    <p
                        style={{
                            fontSize: "13px",
                            color: "rgba(255,255,255,.65)",
                        }}
                    >
                        Pre-money valuation: $100M (target) · Contact: Dee Gulati,
                        CEO & President · 1148 Fifth Avenue, Suite 1C, New York NY
                        10128
                    </p>
                </div>

                <div
                    className="grid g2"
                    style={{ gap: "20px" }}
                >
                    <div className="card">
                        <div
                            style={{
                                fontFamily: "var(--sans2)",
                                fontSize: "11px",
                                color: "var(--coral)",
                                fontWeight: 700,
                                letterSpacing: ".1em",
                                textTransform: "uppercase",
                                marginBottom: "14px",
                            }}
                        >
                            MARKET OPPORTUNITY
                        </div>

                        <div className="mrow">
                            <div className="ml">Dating industry</div>
                            <div className="mv">$10B+</div>
                        </div>

                        <div className="mrow">
                            <div className="ml">Fertility & IVF</div>
                            <div className="mv">$40B+</div>
                        </div>

                        <div className="mrow">
                            <div className="ml">Genetic testing</div>
                            <div className="mv">$25B+</div>
                        </div>

                        <div className="mrow">
                            <div className="ml">AI healthcare</div>
                            <div className="mv">$60B+</div>
                        </div>

                        <div className="mrow">
                            <div className="ml">Combined TAM</div>
                            <div
                                className="mv"
                                style={{
                                    fontSize: "16px",
                                    color: "var(--coral)",
                                }}
                            >
                                $150B+
                            </div>
                        </div>
                    </div>

                    <div className="card">
                        <div
                            style={{
                                fontFamily: "var(--sans2)",
                                fontSize: "11px",
                                color: "var(--coral)",
                                fontWeight: 700,
                                letterSpacing: ".1em",
                                textTransform: "uppercase",
                                marginBottom: "14px",
                            }}
                        >
                            INVESTMENT THESIS
                        </div>

                        <div className="mrow">
                            <div className="ml">Capital invested to date</div>
                            <div className="mv">~$2M</div>
                        </div>

                        <div className="mrow">
                            <div className="ml">Product status</div>
                            <div
                                className="mv"
                                style={{ color: "var(--sage)" }}
                            >
                                Built & launch-ready
                            </div>
                        </div>

                        <div className="mrow">
                            <div className="ml">Gross margins (B2B SaaS)</div>
                            <div className="mv">80–90%</div>
                        </div>

                        <div className="mrow">
                            <div className="ml">Revenue model</div>
                            <div className="mv">90% API licensing</div>
                        </div>

                        <div className="mrow">
                            <div className="ml">Pre-money valuation (target)</div>
                            <div className="mv">$100M</div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="sec sec-blush">
                <div class="sec-label"><span class="overline">Why now</span></div>
                <h2 class="disp-md">Three conditions that make<br />this the right moment.</h2>
                <div class="grid g3" style={{ marginTop: "28px" }}>
                    <div class="card" style={{ borderTop: "3px solid var(--coral)" }}><div>GENOMICS AT SCALE</div><h3>DNA sequencing now costs $200–$600</h3><p>The same panel that cost $5,000 five years ago now costs $200–$600. Consumer DNA compatibility is newly economically viable — and FutureSoulmates is first to file the patent claims.</p></div>
                    <div class="card" style={{ borderTop: "3px solid var(--indigo)" }}><div>DATING MARKET FATIGUE</div><h3>Users are desperate for an exit from swiping</h3><p>Dating app downloads are declining. User satisfaction is at all-time lows. Any platform that can offer provably better matches gains an immediate competitive advantage.</p></div>
                    <div class="card" style={{ borderTop: "3px solid var(--sage)" }}><div>FERTILITY MARKET GROWTH</div><h3>IVF and donor matching now a $40B market</h3><p>Fertility clinics need better matching tools. HLA/KIR compatibility scoring for surrogate selection is a new category — and FutureSoulmates is the only platform offering it.</p></div>
                </div>
            </div>

            <div class="sec sec-white">
                <div class="sec-label"><span class="overline">Use of Investment Proceeds</span></div>
                <h2 class="disp-md">Market development.<br />Not R&amp;D. Product is ready.</h2>
                <div class="grid g2" style={{ marginTop: "28px" }}>
                    <div>
                        <div className="investmentproceed"><div className="investmenttitle"><div className="title">Enterprise Sales &amp; BD</div><div className="subtext">Match Group, Bumble, Shaadi.com pilots · Healthcare SaaS partnerships</div></div><div className="price">$7M</div></div>
                        <div className="investmentproceed"><div className="investmenttitle"><div className="title">DNA Lab Partnerships</div><div className="subtext">CLIA lab agreements · Kit supply chain · Logistics</div></div><div className="price">$4M</div></div>
                        <div className="investmentproceed"><div className="investmenttitle"><div className="title">Marketing &amp; Consumer</div><div className="subtext" >B2C waitlist conversion · Brand &amp; content · Influencer partnerships</div></div><div className="price">$4M</div></div>
                        <div className="investmentproceed"><div className="investmenttitle"><div className="title">Patent &amp; Regulatory</div><div className="subtext">PCT filings Dec 2026 · National phase · GDPR compliance</div></div><div className="price">$2M</div></div>
                        <div className="investmentproceed"><div className="investmenttitle"><div className="title">Operations &amp; Platform</div><div className="subtext" >Engineering · Genetic counsellor network · Customer success</div></div><div className="price">$3M</div></div>
                    </div>
                    <div>
                        <div class="card" style={{
                            background: "var(--indigo-10)",
                            borderColor: "rgba(45, 58, 140, 0.15)"
                        }}>
                            <div>VALUATION RATIONALE</div>
                            <div class="mrow"><div class="ml">Recommended pre-money target</div><div class="mv">$100M</div></div>
                            <div class="mrow"><div class="ml">Round size</div><div class="mv">Confidential</div></div>
                            <div class="mrow"><div class="ml">Post-money</div><div class="mv">$120M</div></div>
                            <div class="mrow"><div class="ml">Dilution</div><div class="mv">~16.7%</div></div>
                            <div class="mrow"><div class="ml">Product risk</div><div class="mv">Eliminated ($2M invested)</div></div>
                            <div class="mrow"><div class="ml">This round is for</div><div class="mv">Market development</div></div>
                            <div >
                                <div class="infopera">At 10–15× forward ARR (targeting $5–10M ARR within 12–18 months), a $100M pre-money valuation is conservative.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <section class="trusted-story">
                <div class="container p-0">
                    <div class="cta-sec cta-coral investorbottomcta">
                        <h2 class="disp-md">The operating system for human compatibility is raising its first institutional round with select strategic investors.</h2>
                        <p>Patent-protected. Product-ready. $150B+ market. This is a market-development round, not a build round.</p><div class="cta-btns">
                            <button class="btn btn-white">Request Investor Deck <span class="arr">→</span></button>
                            <button class="btn investerbtn">Schedule Call: Dee Gulati →</button>
                        </div>
                        <p className="smalltext">DGA, Inc. · 1148 Fifth Avenue, Suite 1C · New York, NY 10128 · Attorney: David K. Bowles, Bowles & Johnson PLLC. This page does not constitute an offer to sell or solicitation of an offer to buy any security. For accredited investors only under SEC Rule 506(c). Not a medical diagnostic service.</p>
                    </div>
                </div>
            </section>



            <Footer />
        </div>
    )
}

export default investors
